<template>
  <div class="main-layout">
    <navbar/>
    <!--nav class="navbar navbar-expand-lg navbar-light bg-white">
      <div class="container">
        <a class="navbar-brand" href="#">Dossier</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <router-link :to="{ name: 'aptitudes' }" v-if="user" class="nav-link text-primary" active-class="active">
                Aptitudes
            </router-link>
            <router-link :to="{ name: 'exigences' }" v-if="user" class="nav-link text-danger" active-class="active">
                Exigences
            </router-link>
            <router-link :to="{ name: 'perceptions' }" v-if="user" class="nav-link text-success" active-class="active">
                Perceptions
            </router-link>
          </ul>
          <form class="form-inline my-2 my-lg-0">
            <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
            <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
          </form>
        </div>
      </div>
    </nav-->
    <div class="main-container">
      <div class="container">
        <child/>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '~/components/Navbar'
import { mapGetters } from 'vuex'

export default {
  name: 'MainLayout',

  components: {
    Navbar
  },

  computed: mapGetters({
    user: 'auth/user'
  })
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/layouts/large.vue